export const POST_LOGIN = 'POST_LOGIN';
export const POST_GUEST_LOGIN = 'POST_GUEST_LOGIN';

export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';
export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS';

export const COMPLETE_3DS = 'COMPLETE_3DS';
export const SET_DEEPLINK_VERIFICATION_INFO = 'SET_DEEPLINK_VERIFICATION_INFO';
export const SET_DEEPLINK_INCENTIVES_INFO = 'SET_DEEPLINK_INCENTIVES_INFO';
export const SET_DEEPLINK_NAVIGATION_INFO = 'SET_DEEPLINK_NAVIGATION_INFO';
export const CLEAR_DEEPLINK_NAVIGATION_INFO = 'CLEAR_DEEPLINK_NAVIGATION_INFO';

export const CLEAR_DEEPLINK_OTP = 'CLEAR_DEEPLINK_OTP';
export const REQUEST_AGE_VERIFICATION_URL_SUCCESS = 'REQUEST_AGE_VERIFICATION_URL_SUCCESS';
export const REQUEST_AGE_VERIFICATION_URL = 'REQUEST_AGE_VERIFICATION_URL';
export const REQUEST_AGE_VERIFICATION_URL_ERROR = 'REQUEST_AGE_VERIFICATION_URL_ERROR';
export const CLEAR_DEEPLINK_PROMO = 'CLEAR_DEEPLINK_PROMO';
export const GOLD_DEEPLINK_ACTIVE = 'GOLD_DEEPLINK_ACTIVE';
export const GOLD_DEEPLINK_SUCCESS = 'GOLD_DEEPLINK_SUCCESS';
export const SET_APPEALABLE_BAN_CHALLENGE_TOKEN = 'SET_APPEALABLE_BAN_CHALLENGE_TOKEN';
export const SET_ARKOSE_DATA_BLOB = 'SET_ARKOSE_DATA_BLOB';
export const SET_DEEPLINK_INTRO_PRICE_INFO = 'SET_DEEPLINK_INTRO_PRICE_INFO';
export const STORE_POST_LOGIN_REDIRECT_PATH = 'STORE_POST_LOGIN_REDIRECT_PATH';
export const SET_DEEPLINK_PROMO = 'SET_DEEPLINK_PROMO';
export const USER_VERIFY_BANNED = 'USER_VERIFY_BANNED';

export const DEEPLINK_TYPE_ACCOUNT_EMAIL = 'account-email';
export const DEEPLINK_TYPE_ACCOUNT_RECOVERY = 'account-recovery';
export const DEEPLINK_TYPE_CAMPAIGN = 'campaign';
export const DEEPLINK_TYPE_INCENTIVE = 'incentive';
export const DEEPLINK_TYPE_TINDER_U = 'tinderu-email';
export const DEEPLINK_TYPE_LOGIN_REDIRECT = 'redirect';
export const DEEPLINK_TYPE_AGE_VERIFICATION = 'age-verification';
export const DEEPLINK_TYPE_MAGIC_LINK_SELECT = 'select';
export const DEEPLINK_TYPE_MAGIC_LINK_WEB_DISCOUNT = 'web_discount';

export const VERIFY_LOGIN_REDIRECT = 'VERIFY_LOGIN_REDIRECT';
export const VERIFY_AGE_VERIFICATION_STATUS = 'VERIFY_AGE_VERIFICATION_STATUS';

// Request Verification
export const SET_SELFIE_VERIFICATION_ATTEMPTED = 'SET_SELFIE_VERIFICATION_ATTEMPTED';

// Underage onboarding
export const SET_UNDERAGE_TOKEN = 'SET_UNDERAGE_TOKEN';
export const SET_IS_UNDERAGE_ONBOARDING = 'SET_IS_UNDERAGE_ONBOARDING';
